import { render, staticRenderFns } from "./pointsGoods.vue?vue&type=template&id=e1a36e6c&scoped=true"
import script from "./pointsGoods.vue?vue&type=script&lang=js"
export * from "./pointsGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a36e6c",
  null
  
)

export default component.exports